module.exports = __webpack_public_path__ + "img/Paypal.619fcd98.png";